<ngc-main class="ngc-main"></ngc-main>
